export function parseBooleanEnv(value: unknown): boolean {
  if (typeof value === 'boolean') return value;
  if (typeof value !== 'string') return false;
  const normalized = value.trim().toLowerCase();
  return normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'y';
}

// Vite only exposes variables prefixed with VITE_ to the client bundle.
export function isSignupEnabledByEnv(): boolean {
  return parseBooleanEnv(import.meta.env?.VITE_SHOW_SIGNUP);
}

// This file handles environment variables in a way that works with both Vite and Jest
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''; 